import { render, staticRenderFns } from "./clueTouchChannel.vue?vue&type=template&id=8bdba2aa&scoped=true&"
import script from "./clueTouchChannel.vue?vue&type=script&lang=js&"
export * from "./clueTouchChannel.vue?vue&type=script&lang=js&"
import style0 from "./clueTouchChannel.vue?vue&type=style&index=0&id=8bdba2aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdba2aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bdba2aa')) {
      api.createRecord('8bdba2aa', component.options)
    } else {
      api.reload('8bdba2aa', component.options)
    }
    module.hot.accept("./clueTouchChannel.vue?vue&type=template&id=8bdba2aa&scoped=true&", function () {
      api.rerender('8bdba2aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/clueTouchChannel/clueTouchChannel.vue"
export default component.exports